import { render, staticRenderFns } from "./thong-ke-phi-mua-hang.vue?vue&type=template&id=0dc3b7a6&"
import script from "./thong-ke-phi-mua-hang.vue?vue&type=script&lang=js&"
export * from "./thong-ke-phi-mua-hang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports